import { TemplateRef } from '@angular/core';
import { WorkflowWebhookModel } from '@models/workflow-webhook.model';
import {
  CellTemplateContext,
  ColumnBuilder,
  DatasetTableConfig,
  TableConfigBuilder,
  deleteAction,
  editAction,
  textColumn,
} from '@ui/lib/ui-kit/ui-dataset-table';

export interface CreateWebhooksTableConfigDependencies {
  templates: {
    connectedGraphCell: TemplateRef<CellTemplateContext<WorkflowWebhookModel.WebhookEndpointMongoDocument>>;
  };
}

export function createWebhooksTableConfig(
  dependencies: CreateWebhooksTableConfigDependencies,
): DatasetTableConfig<WorkflowWebhookModel.WebhookEndpointMongoDocument> {
  const builder = new ColumnBuilder<WorkflowWebhookModel.WebhookEndpointMongoDocument>();

  return new TableConfigBuilder<WorkflowWebhookModel.WebhookEndpointMongoDocument>()
    .columns([
      textColumn<WorkflowWebhookModel.WebhookEndpointMongoDocument>(
        'name',
        'WORKFLOW_WEBHOOK.TABLE_NAME',
        {
          width: 'minmax(220px, 1fr)',
          mobileVisible: true,
          cardMode: 'label-only',
        },
      ),
      builder
        .column('target')
        .label('WORKFLOW_WEBHOOK.TARGET')
        .width('minmax(220px, 1fr)')
        .cellTemplate(dependencies.templates.connectedGraphCell)
        .mobileVisible()
        .cardIcon('ui-icon-link')
        .build(),
    ])
    .actions([
      {
        id: 'run',
        icon: 'ui-icon-play',
        iconType: 'ui-icon',
        label: 'FLOW_CHART.EXECUTE_GRAPG',
        tooltip: 'FLOW_CHART.EXECUTE_GRAPG',
        visible: (row) => Boolean(row.target?.graphId && row.target?.nodeId),
        showInline: true,
      },
      editAction<WorkflowWebhookModel.WebhookEndpointMongoDocument>(),
      deleteAction<WorkflowWebhookModel.WebhookEndpointMongoDocument>(),
    ])
    .defaultRowAction('edit')
    .actionsWidth(120)
    .rowHeight(72)
    .trackBy('_id')
    .build();
}
